<template>
    <div class="principal">
        <NavBar :usarAberto="false" :usarHistorico="false" :usarVoltar="false" :usarDeslogar="true" :usarGerenciar="true"
            :usarInternacao="true" :usarRelatorio="false" :usarFiltros="true" :usarFiltroSetor="true"
            :usarFiltroTpChamado="true" :usarFiltroPosicao="false" :principal="true" :iniciadoPrincipal="state.iniciado"
            @filtrar="filtrar" :formatarDataInicioMes="formatarDataInicioMes" />

        <div class="d-flex flex-wrap jContent gap-3 mb-1" id="divCard" v-show="state.erro == null">
            <Card v-for="dChamado in state.dadosChamados" :key="dChamado.id" :dChamado="dChamado" :tpChamado="tipoChamado"
                v-show="state.iniciado === true" />
            <button class="btn btn-danger btn-iniciar align-self-center" id="btn-iniciar" @click="botaoClick()"
                ng-disabled="desabilitar" v-show="!state.iniciado">
                <p class="texto-botao"> Clique para iniciar o painel </p>
            </button>
        </div>

        <Modal :mostrar="state.erro != null" @fechar="fechar()" :usarCronometro="true">
            <template v-slot:header>
                <p class="erro"> {{ state.erro }} </p>
            </template>
            <template v-slot:corpo>
                O sistema expirou, entre em contato com o suporte
            </template>
        </Modal>
    </div>
</template>

<script setup>
import Card from '@/components/Card.vue';
import api from "@/api/api";
import Chamado from '@/model/Chamado';
import Leito from '@/model/Leito';
import Quarto from '@/model/Quarto';
import Setor from '@/model/Setor';
import TipoChamado from '@/model/TipoChamado';
import store from '@/store/store';
import somHotelaria from '@/assets/som/hotel.mp3';
import somEnfermagem from '@/assets/som/enfermagem.mp3';
import somUrgencia from '@/assets/som/urgencia.mp3';
import somIniciar from '@/assets/som/iniciar.mp3';
import Modal from '@/components/Modal.vue';
import _versao from '@/../package.json';
import NavBar from '@/components/NavBar.vue';
import { reactive, onMounted, computed, defineProps } from 'vue';
import moment from 'moment';

const props = defineProps(['formatarDataInicioMes']);

const state = reactive({
    dadosChamados: [],
    valorFiltroSetor: 0,
    valorFiltroTPChamado: 0,
    valorFiltroQuarto: 0,
    valorFiltroLeito: 0,
    valorOrderData: 'desc',
    iniciado: false,
    erro: null,
    count: 0,
    versao: _versao.version,
});

function excluir(id) {
    state.dadosChamados = state.dadosChamados.filter(ch => ch.id != id);
}

function adicionar(pChamado) {
    if (pChamado.tipoChamado.urgencia) {
        state.dadosChamados.unshift(
            new Chamado(
                pChamado.id,
                pChamado.data,
                pChamado.hora,
                new Leito(pChamado.leito.id, pChamado.leito.codigoLeito, pChamado.leito.descricao, pChamado.leito.ativo,
                    new Quarto(pChamado.leito.quarto.id, pChamado.leito.quarto.codigoQuarto, pChamado.leito.quarto.descricao, pChamado.leito.quarto.ativo,
                        new Setor(pChamado.leito.quarto.setor.id, pChamado.leito.quarto.setor.ativo, pChamado.leito.quarto.setor.codigoSetor, pChamado.leito.quarto.setor.descricao)
                    )
                ),
                new TipoChamado(pChamado.tipoChamado.id, pChamado.tipoChamado.descricao, pChamado.tipoChamado.ativo, pChamado.tipoChamado.cor, pChamado.tipoChamado.som, pChamado.tipoChamado.fonte, pChamado.tipoChamado.borda, pChamado.tipoChamado.corIcone, pChamado.tipoChamado.urgencia, pChamado.tipoChamado.id_Principal),
                pChamado.posicao,
                pChamado.dtFinalizacao,
                pChamado.hrFinalizacao,
                pChamado.dtCancelamento,
                pChamado.hrCancelamento,
                pChamado.motivo
            )
        );
    } else {
        state.dadosChamados.push(
            new Chamado(
                pChamado.id,
                pChamado.data,
                pChamado.hora,
                new Leito(pChamado.leito.id, pChamado.leito.codigoLeito, pChamado.leito.descricao, pChamado.leito.ativo,
                    new Quarto(pChamado.leito.quarto.id, pChamado.leito.quarto.codigoQuarto, pChamado.leito.quarto.descricao, pChamado.leito.quarto.ativo,
                        new Setor(pChamado.leito.quarto.setor.id, pChamado.leito.quarto.setor.ativo, pChamado.leito.quarto.setor.codigoSetor, pChamado.leito.quarto.setor.descricao)
                    )
                ),
                new TipoChamado(pChamado.tipoChamado.id, pChamado.tipoChamado.descricao, pChamado.tipoChamado.ativo, pChamado.tipoChamado.cor, pChamado.tipoChamado.som, pChamado.tipoChamado.fonte, pChamado.tipoChamado.borda, pChamado.tipoChamado.corIcone, pChamado.tipoChamado.urgencia, pChamado.tipoChamado.id_Principal),
                pChamado.posicao,
                pChamado.dtFinalizacao,
                pChamado.hrFinalizacao,
                pChamado.dtCancelamento,
                pChamado.hrCancelamento,
                pChamado.motivo
            )
        );
    }
}

function cronometro() {
    setTimeout(() => {
        setInterval(() => {
            filtrar(true, state.valorFiltroSetor, state.valorFiltroTPChamado);
        },
            // 1000
            // 1000 * this.config.atualizacao
            1000 * (config?.value?.atualizacao ?? 15) / 2
        );
    }, 2000);//Para aguardar carregar o config
}

function audioPlay(enderecoSom) {
    let audio = new Audio(enderecoSom);
    audio.play();
}

function botaoClick() {
    if (moment().isSameOrAfter(moment('30-12-2026', 'DD-MM-YYYY'))) {
        state.erro = true;
    }else{
        audioPlay(somIniciar);
        state.iniciado = true;
        cronometro();
    }
}

async function filtrar(pAtualizando, pValorFiltroSetor, pValorFiltroTPChamado) {
    // console.log(pAtualizando);
    // console.log(pValorFiltroSetor);
    // console.log(pValorFiltroTPChamado);
    state.valorFiltroTPChamado = pValorFiltroTPChamado;
    state.valorFiltroSetor = pValorFiltroSetor;
    await api.filtrarDados("AB", state.valorFiltroTPChamado, state.valorFiltroSetor,
        state.valorFiltroQuarto, state.valorFiltroLeito, true, false, false, false,
        state.valorOrderData, state.valorOrderHora, "")
        .then(resposta => {
            let auxiliar = [];
            let tocouU = false;
            let tocouE = false;
            let tocouH = false;

            // console.log(resposta);

            //excluindo
            state.dadosChamados.forEach((a) => {
                let encontrou = false;
                if (a != null) {

                    resposta.forEach(r => {
                        if (a.id === r.id) {
                            encontrou = true;
                        }
                    });

                    if (!encontrou) {
                        auxiliar.push(a.id);
                    }
                }
            });

            auxiliar.forEach(id => {
                excluir(id);
            });

            auxiliar = [];

            resposta.forEach(r => {
                let encontrou = false;
                state.dadosChamados.forEach((a) => {
                    if (a.id === r.id) {
                        encontrou = true;
                    }
                });
                if (!encontrou) {
                    adicionar(r);
                    if (pAtualizando) {
                        if (r.tipoChamado.id === 3 && tocouU === false) {
                            audioPlay(somUrgencia);
                            tocouU = true;
                        } else if (r.tipoChamado.id === 2 && tocouE === false) {
                            audioPlay(somEnfermagem);
                            tocouE = true;
                        } else if (r.tipoChamado.id === 1 && tocouH === false) {
                            audioPlay(somHotelaria);
                            tocouH = true;
                        }
                    }
                }
            });
        })
        .catch(error => {
            state.erro = error;
        });
}

function fechar() {
    if (state.filtrar) {
        state.erro = null;
    }
}

function deslogar() {
    sessionStorage.removeItem("TokenReguaPainel");
    location.reload();
}

const setores = computed(() => {
    return store.state.setores;
});
const config = computed(() => {
    return store.state.config;
});
const tipoChamado = computed(() => {
    return store.state.tipoChamado;
});
const token = computed(() => {
    return (sessionStorage.TokenReguaPainel) ? true : false;
});

</script>

<style scoped>
.btn {
    justify-content: flex-end;
}

.btn-iniciar {
    width: 500px;
    height: 150px;
    border-radius: 20%;
}

.texto-botao {
    font-size: 22px;
}

.btn-iniciar:hover {
    box-shadow: rgba(151, 11, 11, 1) 0px 22px 70px 4px;
}

.erro {
    text-align: left;
}

@media only screen and (max-width : 500px) {
    .btn-iniciar {
        width: 250px;
        height: 75px;
    }
}
</style>